import { memo } from 'react';
import { RewardType } from 'root/src/shared/rewards/constants';
import { ProgressBar, toPercentage } from 'root/src/client/v2/common/components/ui/progress';
import { cn } from 'root/src/client/v2/common/helpers/cn';
// Custom and external-API rewards have no countable pool. The drop serializer hands them a
// { available: 1, used: 0 } sentinel and project metadata leaves them at 0, so neither number means
// anything: both read as Unlimited rather than as a meter.
export const isUncountableReward = (type) => (type === RewardType.CUSTOM || type === RewardType.EXTERNAL_API_FULFILLED);
// How many of a reward are left out of what the brand stocked, restoring the legacy meter
// (web/list/listItemComponents/dare/DareCardBody.js and .../project/ProjectCardRewardRemaining.tsx).
// `capacity.available` is ALREADY the remaining count (the counter decrements it on each redemption
// and increments `used`), so the pool the brand originally stocked is available + used. Do NOT
// subtract `used` from `available` or every redemption gets counted twice.
export const RewardRemaining = memo(({ capacity, isUnlimited, className }) => {
    if (isUnlimited) {
        return <p className={cn('text-xs font-medium text-muted-foreground', className)}>Unlimited</p>;
    }
    if (!capacity) {
        return null;
    }
    const remaining = Math.max(0, capacity.available);
    const total = Math.max(0, capacity.available + capacity.used);
    return (<div className={className}>
			<div className="flex items-center justify-between gap-2 text-xs">
				<span className="text-muted-foreground">Remaining</span>
				<span className="font-semibold text-foreground">{remaining} / {total}</span>
			</div>
			<ProgressBar value={toPercentage(remaining, total)} className="mt-1"/>
		</div>);
});
